import axios from './axios';

export default {
  get: async () => {
    const { data } = await axios.get('/template-fields');
    return data;
  },

  getKinds: async () => {
    const { data } = await axios.get('/kinds');
    return data;
  }
};
